<script>
    import { createEventDispatcher } from 'svelte';
    import { urlapi } from '../stores/store';

    export let id=false;
    export let imageBASE64=false;
    export let image=false;
    export let color='';
    export let precio='';
    export let disabled=false;
    export let width='100%';

    const dispatch = createEventDispatcher();

    function hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : null;
    }
    function transparencyRGB(color, transparency) {
      let gcolor=hexToRgb(color);
      if(gcolor!==null) {
          return `rgba(${gcolor.r},${gcolor.g},${gcolor.b},${transparency})`
      }
    }
    function click() {
		dispatch('click', {});
	}    
</script>


<button disabled={disabled} on:click={click} style='background:{transparencyRGB(color,0.1)};width:{width};border:10px solid {color} !important;' class='btn fw-bold border border-1 border-dark'>
    {#if imageBASE64}
      <img src="{imageBASE64}" alt="">
    {:else if image==1 || imageBASE64!==false}
      <img src="{$urlapi}/upload/{id}.png?{Math.random()}" alt="">
    {:else}
      <img src="{$urlapi}/upload/default.png" alt="">
    {/if}

    <p class='lh-1 mb-0'><small><slot/></small></p>
    <span class='text-primary'>Q.{precio}</span>
</button>

<style>
  img {
    width:100px;
    max-width:100%;
    display:block;
    margin:auto;
  }
</style>
